import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";

export default function GeneratedVideoAi() {
    const { AIuser } = useContext(UserAuthContext);
    const [videoUrl, setVideoUrl] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const data = location.state || {};

    const creditToLocalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";

    useEffect(() => {
        const url = data?.videoAi || data?.videoUrl;
        if (!url) {
            navigate("/usage");
            return;
        }
        setVideoUrl(url);
        setIsLoading(false);
        window.scrollTo(0, 0);
    }, [data?.videoAi, data?.videoUrl, navigate]);

    if (!location.state) {
        return (
            <div>
                <PageHeading
                    title={"GENERATED VIDEO AI"}
                    description={"View your generated video"}
                />
                <div className="container text-center" style={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <h5 className="text-white">No data found</h5>
                </div>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "80vh" }}
            >
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    return (
        <div>
            <PageHeading
                title={"GENERATED VIDEO AI"}
                description={"View your generated video"}
            />

            <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-4 mb-4">
                <button className="credits-button">
                    CREDITS : {creditToLocalString}
                </button>
                <button
                    className="buy-credits-button"
                    onClick={() => navigate("/purchase")}
                >
                    BUY CREDITS
                </button>
                <button
                    onClick={() => navigate("/usage")}
                    className="money-exchange-button"
                >
                    <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
                </button>
            </div>

            <div
                className="container"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: "60vh",
                    paddingInline: "12px",
                    maxWidth: "872px",
                }}
            >
                {videoUrl && (
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "720px",
                            marginBottom: "24px",
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        }}
                    >
                        <video
                            src={videoUrl}
                            controls
                            autoPlay
                            muted
                            style={{
                                width: "100%",
                                display: "block",
                            }}
                        />
                    </div>
                )}

                {!videoUrl && (
                    <div
                        className="d-flex flex-column align-items-center justify-content-center text-white text-center"
                        style={{
                            width: "100%",
                            minHeight: "300px",
                            background: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "12px",
                        }}
                    >
                        <h5 className="mb-2">No Video Available</h5>
                        <p>The video will appear here once it is generated</p>
                    </div>
                )}

                {data?.remarks && (
                    <div className="text-white text-center mt-3">
                        <p className="mb-1" style={{ opacity: 0.8 }}>{data.remarks}</p>
                        {data?.requestQues && (
                            <p style={{ fontStyle: "italic", maxWidth: "600px", margin: "0 auto" }}>"{data.requestQues}"</p>
                        )}
                    </div>
                )}

                <div className="d-flex flex-wrap justify-content-center gap-3 w-100 mt-4" style={{ marginBottom: "48px" }}>
                    <button
                        onClick={() => navigate("/video-ai")}
                        className="btn btn-primary flex-grow-1"
                        style={{ maxWidth: "320px" }}
                    >
                        Generate New Video
                    </button>
                </div>
            </div>
        </div>
    );
}